<template>
  <div id="tradeLeadDetail" style="background: #f5f5f5; height: 100%; box-sizing: border-box; padding-top: 46px; overflow-y: auto">
    <NavBar fixed title="供求详情">
      <template #left><Icon @click="allReturn()" name="arrow-left" size="22" color="#666"/></template>
    </NavBar>
    <div>
      <div class="message-card" @click="showLoad = false">
        <div class="message-card__avatar" style="top: 0">
          <!--							<VanImage-->
          <!--								width="2rem"-->
          <!--								height="2rem"-->
          <!--								src="https://img.yzcdn.cn/vant/cat.jpeg"/>-->
          <VanImage
              width="2rem"
              height="2rem"
              :src="myData.userModel.headBigImage"/>
        </div>
        <div class="message-card__content">
          <div class="d_f_lr" style="padding: 0 10px 5px 0">
            <span class="message-card__content-name">{{myData.userModel.nickName}}</span>
<!--            <span v-if="parseInt($store.state.userFromJava.id) === parseInt(myData.userId)" @click.stop="allDelt(myData, index)" style="color: red">删除</span>-->
          </div>
          <div class="message-card__content-text" style="padding-right: 10px">{{myData.content}}</div>
          <div class="ExploreDiv" v-if="myData.exploreMsgImage.length > 0">
            <ul v-if="myData.messagetype === 'image'">
              <li :key="imgIndex" v-for="(imgItem, imgIndex) in myData.exploreMsgImage" :style="myData.exploreMsgImage.length === 1 ? 'width: 180px;height:auto' : 'width: 25vw;height:25vw'">
                <div v-if="myData.exploreMsgImage.length > 1">
                  <img :class="imgItem.isMaxWidth ? 'maxHeight' : 'maxWidth'" :preview="'1'" :src="imgItem.imageUrl">
                </div>
                <img v-if="myData.exploreMsgImage.length === 1" :preview="'1'" :src="imgItem.imageUrl" style="width: 100%">
              </li>
            </ul>
          </div>
          <div v-if="myData.messagetype === 'video'" style="width: 40%">
            <video :poster="myData.videoThumbUrl || ''" width="100%" controls>
              <source :src="myData.videoUrl" type="video/mp4">
              <!--                    <source src="../assets/1.mp4" type="video/mp4">-->
            </video>
          </div>
          <div class="d_f_lr" style="padding: 10px 10px 0 0">
            <span style="color: #737373">{{$commonJs.returnTimeago(myData.createTime)}}</span>
            <div class="d_f_lr" style="width: 50%;justify-content: flex-end">
              <div style="width: 79px" class="NoWrap">
                <Icon @click.stop="allLike()" :name="parseInt(myData.isUp) === 1 ? 'good-job' : 'good-job-o'" color="#576b95" size="22" style="vertical-align: middle;"></Icon>
                <span style="vertical-align: middle;">{{myData.upNum}}</span>
              </div>
              <Icon @click.stop="seltload( 1)" name="chat" size="22" color="#576b95" style="margin-left: 10px;"></Icon>
            </div>
          </div>
          <div class="message-card__content-replay p_r" v-if="myData.upUserInfos.length > 0 || myData.reverts.length > 0">
            <section class="ArrowDiv"></section>
            <div class="PrincetonDiv">
              <ul v-if="myData.upUserInfos.length > 0" style="border-bottom: none">
                <li :key="upUserIndex" v-for="(upUserItem, upUserIndex) in myData.upUserInfos.slice(0,5)"><img :src="upUserItem.headBigImage"/></li>
                <li v-if="myData.upUserInfos.length > 6" @click="toNewUrl('tradeLeadLike', myData)"><Icon name="ellipsis" color="#fff" size="22"/></li>
              </ul>
            </div>
          </div>
        </div>
      </div>
      <div class="RrevDiv">
        <div>
          <ul>
            <li :key="index" v-for="(item, index) in myFirstCommentList">
              <div>
                <img :src="item.headBigImage">
              </div>
              <div>
                <p>
                  <span style="color: rgba(2, 44, 86, 1)">{{item.replyNickName}}</span>
                  <span @click.stop="seltload( 2, item)">回复TA</span>
                </p>
                <p>{{item.content}}</p>
                <div class="clrevDiv">
                  <ul>
                    <li :key="reventChildIndex" v-for="(reventChildItem, reventChildIndex) in item.revertDetails.slice(0, item.isShowPl ? item.revertDetails.length : 5)">
                      <div @click.stop="seltload( 3, reventChildItem, item)">
                        <span style="color: #576b95">{{reventChildItem.nikeName}} </span>
                        <span v-if="parseInt(reventChildItem.receiveId) !== parseInt(item.replyUserId)">回复</span>
                        <span v-if="parseInt(reventChildItem.receiveId) !== parseInt(item.replyUserId)" style="color: #576b95"> {{reventChildItem.beReturnedNickName}} ： </span><span>{{reventChildItem.content}}</span>
                      </div>
                    </li>
                    <li v-if="item.revertDetails.length > 6">
                      <span @click="seltPl(item)" style="color: #999999">{{ item.isShowPl ? '收起' : '展开' }}全部{{myData.revertNum}}条回复</span>
                    </li>
                  </ul>
                </div>
              </div>
            </li>
          </ul>
<!--          <ul>-->
<!--            <li :key="reventIndex" v-for="(reventItem, reventIndex) in myData.reverts">-->
<!--              <div :style="reventItem.revertDetails && reventItem.revertDetails.length > 0 ? 'margin-bottom: 10px' : ''" @click.stop="seltload(reventItem, 2, index, reventIndex)">-->
<!--                <span style="color: #576b95">{{reventItem.replyNickName}}</span>： {{reventItem.content}}-->
<!--              </div>-->
<!--              <div :key="reventChildIndex" v-for="(reventChildItem, reventChildIndex) in reventItem.revertDetails">-->
<!--                <span style="color: #576b95">{{reventChildItem.nikeName}} </span><span>回复</span><span style="color: #576b95"> {{reventChildItem.beReturnedNickName}}</span>： {{reventChildItem.content}}-->
<!--              </div>-->
<!--            </li>-->
<!--          </ul>-->
        </div>
      </div>
    </div>
    <div class="loadDiv" v-if="showLoad">
      <input v-model="repContent" type="text" class="allInput" id="loadInput" :placeholder="newPlaceholder">
      <div @click.stop="allSend()">发送</div>
    </div>
  </div>
</template>

<script>
import { NavBar, Icon, Image as VanImage, PullRefresh, List } from 'vant'

export default {
  name: 'tradeLeadDetail',
  components: {
    NavBar,
    Icon,
    VanImage,
    PullRefresh,
    List
  },
  data () {
    return {
      myData: {
        content: '',
        createTime: '',
        exploreMsgImage: [],
        groupId: 0,
        heading: null,
        id: 0,
        isUp: '',
        messagetype: 'image',
        reportMark: false,
        reportNum: 0,
        revertNum: 0,
        reverts: [],
        topStatus: false,
        topTime: null,
        unusedField: null,
        upNum: 0,
        upUserInfos: [],
        userId: 0,
        userModel: {
          headBigImage: '',
          nickName: '',
          userId: 0
        },
        videoProportion: '',
        videoThumbUrl: '',
        videoTime: null,
        videoUrl: '',
      },
      formId: parseInt(this.$route.query.formId),
      list: [],
      page: 1,
      size: 20,
      newPlaceholder: '',
      showLoad: false,
      userInfo: JSON.parse(localStorage.huozhewang_userInfo),
      userFromJava: this.$store.state.userFromJava,
      repType: 1,
      repContent: '',
      repData: {},
      fatherRevenIndex: '',
      childRevenIndex: '',
      unReadNum: 0,
      myFirstCommentList: [],
      myLastCommentList: []
    }
  },
  created() {
    this.getAllDetail()
  },
  mounted() {
  },
  methods: {
    allReturn () {
      this.$router.go(-1)
    },
    getAllDetail () {
      let data = {
        id: this.formId,
        upSize: 6
      }
      this.$axiox.post('/explore/exploreDetail', data).then(msg => {
        this.handleImg(msg.data)
        this.getFirstCommentList()
        this.$nextTick(p => {
          this.$previewRefresh()
        })
      })
    },
    async handleImg (msg) {
      this.myData = msg
      for (let j = 0; j <  this.myData.exploreMsgImage.length; j++) {
        let data = await this.getImgWidth( this.myData.exploreMsgImage[j].imageUrl)
        // this.myData.exploreMsgImage[j].isMaxWidth = data.width > data.height
        this.$set(this.myData.exploreMsgImage[j], 'isMaxWidth',  data.width > data.height)
      }
    },
    getImgWidth (imgSrc) {
      return new Promise((resolve, reject) => {
        const img = new Image()
        img.src = imgSrc
        img.onload = () => {
          resolve(img)
        }
      })
    },
    getFirstCommentList () {
      let data = {
        exploreId: this.formId,
        page: 1,
        size: 9999
      }
      this.$axiox.post('/explore/showFirstComment', data).then(msg => {
        this.myFirstCommentList = msg.data.content || []
        for (let i = 0; i < this.myFirstCommentList.length; i++) {
          this.$set(this.myFirstCommentList[i], 'isShowPl', false)
        }
      })
    },
    seltPl (item) {
      item.isShowPl = !item.isShowPl
    },
    getLastCommentList (id) {
      let data = {
        firstCommmetId: id,
        page: 1,
        size: 9999
      }
      this.$axiox.post('/explore/showSecondComment', data).then(msg => {
        this.myLastCommentList = msg.data.content || []
      })
    },
    allLike () {
      // this.myData.isUp = !this.myData.isUp
      this.myData.isUp = parseInt(this.myData.isUp) === 0 ||  this.myData.isUp === null ? 1 : 0
      // this.myData.isUp = this.myData.isUp^1
      if (parseInt(this.myData.isUp) === 1) {
        console.log('点赞')
        let data = {
          id: this.myData.id,
          upSize: 5
        }
        this.$axiox.post('/explore/upExploreMessage', data).then(msg => {
          this.myData.upNum = msg.data.upVoteNum
          this.myData.upUserInfos = msg.data.upUserList
          this.$commonJs.showTips('点赞成功')
        })
      } else {
        console.log('取消')
        let data = {
          id: this.myData.id,
          upSize: 5
        }
        this.$axiox.post('/explore/cancelUpExploreMessage', data).then(msg => {
          this.myData.upNum = msg.data.upVoteNum
          this.myData.upUserInfos = msg.data.upUserList || []
          this.$commonJs.showTips('取消点赞')
        })
      }
      this.$forceUpdate()
    },
    allDelt (item, index) {
      this.$commonJs.doubleComfirm({
        title: '提示',
        content: '是否确定删除',
        buttonType: '2',
        successFun: () => {
          let data = {
            id: item.id
          }
          this.$axiox.post('/explore/clearMsg', data).then(() => {
            this.$commonJs.showTips('删除成功')
            this.list.splice(index, 1)
          })
        },
        errorFun: () => {
        }
      })
    },
    seltload (num, tewItem, fistItem) {
      this.repType = num
      this.repContent = ''
      if (num === 1) {
        this.newPlaceholder = '请输入'
        this.showLoad = true
      } else if (num === 2) {
        this.repData = JSON.parse(JSON.stringify(tewItem))
        this.newPlaceholder = '回复 ' + tewItem.replyNickName || tewItem.nikeName
        this.showLoad = true
      } else {
        this.repData = JSON.parse(JSON.stringify(tewItem))
        this.repFistData = JSON.parse(JSON.stringify(fistItem))
        this.newPlaceholder = '回复 ' + tewItem.nikeName
        this.showLoad = true
      }
      this.$nextTick(() => {
        document.getElementById('loadInput').focus()
      })
    },
    allSend () {
      if (parseInt(this.repType) === 1) {
        let data = {
          id: this.myData.id,
          content: this.repContent
        }
        this.$axiox.post('/explore/replyExploreMessage', data).then(msg => {
          this.getFirstCommentList()
          this.repContent = ''
          this.showLoad = false
        })
      } else if (parseInt(this.repType) === 2) {
        let data = {
          beReturnedUserId: this.repData.replyUserId || this.repData.userId,
          content: this.repContent,
          revertId: this.repData.id
        }
        this.$axiox.post('/explore/replyExploreRevert', data).then(msg => {
          this.getFirstCommentList()
          this.repContent = ''
          this.showLoad = false
        })
      } else {
        let data = {
          beReturnedUserId: this.repData.userId,
          content: this.repContent,
          revertId: this.repFistData.id
        }
        this.$axiox.post('/explore/replyExploreRevert', data).then(msg => {
          this.getFirstCommentList()
          this.repContent = ''
          this.showLoad = false
        })
      }
    }
  }
}
</script>

<style lang="less" scoped>
.RrevDiv {
  margin-top: 10px;

}
.RrevDiv > div > ul > li {
  padding: 10px 4%;
  background-color: white;
  border-bottom: 1px solid rgba(239, 239, 239, 1);
}
.RrevDiv > div > ul > li > div:first-child {
  width: 32px;
  height: 32px;
  display: inline-block;
  vertical-align: top;
}
.RrevDiv > div > ul > li > div:first-child img {
  width: 100%;
  height: 100%;
  border-radius: 100%;
}
.RrevDiv > div > ul > li > div:last-child {
  width: calc(100% - 42px);
  display: inline-block;
  vertical-align: top;
  margin-left: 10px;
}
.RrevDiv > div > ul > li > div:last-child > p:first-child {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.RrevDiv > div > ul > li > div:last-child > p:first-child span:last-child {
  display: inline-block;
  padding: 0px 8px;
  background-color: rgba(243, 243, 243, 1);
  color: rgba(81, 90, 109, 1);
  border-radius: 100px 100px;
}
.RrevDiv > div > ul > li > div:last-child > p:nth-child(2) {
  line-height: normal;
  margin-top: 5px;
  margin-bottom: 8px;
  font-size: 14px;
}
.clrevDiv {
  background-color: rgba(246, 246, 246, 1);
}
.clrevDiv ul li {
  padding: 5px 6px;
  font-size: 14px;
}
.clrevDiv ul li:last-child {
  //border-top: 1px solid rgba(236, 236, 236, 1);
}
.loadDiv {
  background-color: white;
  padding:10px;
  position: fixed;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 100;
}
.loadDiv > input {
  width: calc(100% - 80px);
  background-color: #f5f5f5;
  margin-right: 10px;
  border-radius: 4px;
  padding: 8px;
  font-size: 14px;
}
.loadDiv > input::placeholder {
  font-size: 14px;
}
.loadDiv > div {
  display: inline-block;
  vertical-align: middle;
  padding: 5px 10px;
  background-color: #ee0a24;
  border-radius: 5px;
  color: white;
  font-size: 16px;
}
.PrincetonDiv {
  background-color: #f5f5f5;
  margin-right: 10px;
}
.PrincetonDiv > ul {
  white-space: nowrap;
  border-bottom: 1px solid #e1e1df;
}
.PrincetonDiv > ul li {
  display: inline-block;
  width: calc(10vw - 3px);
  height: calc(10vw - 3px);
  vertical-align: middle;
  margin: 5px;
  border-radius: 100%;
}
.PrincetonDiv > ul li img {
  width: 100%;
  height: 100%;
  border-radius: 100%;
}
.PrincetonDiv > ul li:last-child {
  background-color: #97aad0;
  border-radius: 100%;
  text-align: center;
  line-height: calc(10vw - 3px);
}
.PrincetonDiv > div > ul {
  padding-top: 10px;
}
.PrincetonDiv > div > ul li {
  padding: 0 10px 10px 10px;
  white-space: normal;
}
.NoWrap{
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.ExploreDiv {
  width: 100%;
  padding-top: 10px;
}
.ExploreDiv ul {
  white-space: normal;
}
.ExploreDiv ul li {
  display: inline-block;
  vertical-align: middle;
  width: 25vw;
  height: 25vw;
  margin-right: 10px;
  margin-bottom: 10px;
}
.ExploreDiv ul li > div {
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  overflow: hidden;
}
.d_f_lr {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.flex-box {
  display: flex;
  justify-content: center;
  padding: 14px;
  background-color: #fff;
}

.message-notice {
  width: 180px;
  display: flex;
  align-items: center;
  justify-content: space-around;
  background-color: #383839;
  border-radius: 5px;
  padding: 5px;
  color: #fff;
  font-size: 13px;
}

.message-card {
  display: flex;
  align-items: flex-start;
  font-size: 15px;
  color: #000;
  padding: 15px 0px 20px 0;
  background-color: #fff;
  border-bottom: 1px solid #e1e1df;

  &__avatar {
    margin: 0px 10px;
    position: relative;
    top: 6px;
  }

  &__content {
    flex: 1;
  }

  &__content-name {
    font-size: 15px;
    color: #576b95;
  }

  &__content-photo {
    margin: 10px 0px;

    .row {
      margin-bottom: 7px;
      height: 80px;
    }

    .col {
      display: inline-block;
      margin-right: 7px;
      width: 80px;
      height: 80px;
    }

    .row.hasOne {
      height: 200px;

      .col {
        width: 200px;
        height: 200px;
      }
    }

    .photo-item {
      width: 100%;
      height: 100%;
    }

  }

  &__content-operate {
    color: #666;
    font-size: 14px;
    display: flex;
    align-items: center;

    .lover {
      margin-left: 120px;
      margin-right: 20px;
      display: flex;
      align-items: flex-end;
    }

    .replay {
      display: flex;
    }

  }

}
</style>

